<template>
  <!-- <iscroll-view
    name="order-timeline-iscroll"
    v-if="!isMobile"
    ref="scrollView"
    class="scroll-view"
    :options="iscrollOptions"
  > -->
  <v-list two-line class="order-list">
    <div v-if="noDataVisible" class="text-xs-center grey--text title py-4">
      {{ $t('no_data') }}
    </div>
    <div v-for="(item, index) in ordersTimeline" :key="index">
      <v-divider v-if="index !== 0"></v-divider>
      <v-list-tile class="timeline__row" :key="index" avatar :to="'/record/' + item.order_id">
        <v-list-tile-avatar>
          <img
            :src="item.data.order_avatar"
            v-img-fallback="'/assets/images/notification-icon.png'"
          />
        </v-list-tile-avatar>

        <v-list-tile-content :title="item.data.pathTile">
          <div class="body-1">
            <span
              v-dompurify-html="
                $t('order_timeline.status_tracker.' + item.type, {
                  supplier_name: item.data.supplier_name,
                  order_id: item.order_id
                })
              "
            ></span>
          </div>
          <!-- <v-list-tile-title v-dompurify-html="$t('order_timeline.status_tracker.'+ item.type, {supplier_name: item.data.supplier_name, order_id: item.order_id})"></v-list-tile-title> -->
          <v-list-tile-sub-title>
            {{ item.data['format_' + item.type] }}
            <v-icon small>person</v-icon>
            {{ item.data.user_name }}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </div>
  </v-list>
  <!-- </iscroll-view> -->
</template>
<script>
// import IScrollView from "vue-iscroll-view";
// import IScroll from "iscroll";
// Vue.use(IScrollView, IScroll);

import record from '../mixins/record'
import { getServiceDetail } from '../plugins/util'

const { sortBy } = require('@/plugins/lodash')

const COUNT = 10
export default {
  name: 'OrderTimeline',
  mixins: [record],
  data() {
    return {
      ordersTimeline: [],
      statusStatistic: {},
      iscrollOptions: {
        mouseWheel: true,
        scrollbars: 'custom',
        interactiveScrollbars: false,
        useTransition: false
      },
      dataLoading: false,
      reloadOrderTimeout: undefined
    }
  },
  computed: {
    services() {
      return this.$store.state.serviceTypes.service_types
    },
    noDataVisible() {
      return this.ordersTimeline.length === 0 && !this.dataLoading
    }
  },
  methods: {
    loadOrdersTimeline() {
      this.dataLoading = true
      const params = Object.assign({
        offset: 0,
        count: COUNT,
        timeout: this.$constants.HTTP_REQUEST.TIMEOUT,
        token: this.$store.getters.token
      })
      this.$_globalMixin_loadOrdersList(params)
        .then((data) => {
          this.buildTimeline(data)
          this.dataLoading = false
          this.$nextTick(() => {
            if (this.$refs.scrollView) {
              this.$refs.scrollView.refresh()
            }
          })
        })
        .catch((error) => {
          console.log('Order timeline error: ', error)
          this.dataLoading = false
        })
    },
    getPathLabel(path) {
      let result = ''
      path.forEach((p) => {
        result += p.address.substr(0, 50) + '...\n'
      })
      return result
    },
    buildTimeline(orders) {
      const timeProcess = [
        'create_time',
        'cancel_time',
        'accept_time',
        'complete_time',
        'pickup_time'
      ]
      const result = []
      orders.forEach((order) => {
        const service = getServiceDetail(this.services, order.service_id)
        this.$_record_updateOrderGeneral(order, service)
        order.pathTile = this.getPathLabel(order.path)
        const ordersTimeline = []
        timeProcess.forEach((key) => {
          if (order[key])
            ordersTimeline.push({
              order_id: order._id,
              time: order[key],
              type: key,
              data: order
            })
        })
        result.push(...ordersTimeline)
      })
      this.ordersTimeline = sortBy(result, (item) => {
        return -item.time
      })
    }
  },
  beforeMount() {
    this.loadOrdersTimeline()
    this.$root.$on('updateOrderTimeline', () => {
      if (this.reloadOrderTimeout) clearTimeout(this.reloadOrderTimeout)
      this.reloadOrderTimeout = setTimeout(() => {
        this.loadOrdersTimeline()
      }, 5000)
    })
  }
}
</script>

<i18n>
  {
    "en": {
      "order_timeline": {
        "status_tracker": {
          "create_time": "Assigning driver: <strong>#{order_id}</strong>",
          "accept_time": "<strong>{supplier_name}</strong> has accepted your order: <strong>#{order_id}</strong>",
          "cancel_time": "Order <strong>#{order_id}</strong> has been canceled",
          "board_time": "<strong>{supplier_name}</strong> has arrived. Your order <strong>#{order_id}</strong> is in process",
          "pickup_time": "<strong>{supplier_name}</strong> has picked up your package(s). Your order <strong>#{order_id}</strong> is in process",
          "complete_time": "Order <strong>#{order_id}</strong> has been completed"
        }
      }
    },
    "vi": {
      "order_timeline": {
        "status_tracker": {
          "create_time": "Đơn hàng <strong>#{order_id}</strong> đang tìm người cung cấp dịch vụ",
          "accept_time": "Tài xế <strong>{supplier_name}</strong> đã chấp nhận đơn hàng <strong>#{order_id}</strong>",
          "cancel_time": "Đơn hàng <strong>#{order_id}</strong> đã bị huỷ",
          "board_time": "Đơn hàng <strong>#{order_id}</strong> đang được thực hiện",
          "pickup_time": "Tài xế đã lấy hàng. Đơn hàng <strong>#{order_id}</strong> đang được thực hiện",
          "complete_time": "Đơn hàng <strong>#{order_id}</strong> đã được giao thành công"
        }
      }
    }
  }
</i18n>

<style lang="scss" scoped>
.scroll-view {
  -ms-touch-action: none;
  touch-action: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 1;
}

.order-list {
  min-height: 70vh;
}
</style>

<style lang="scss">
.timeline__row {
  .v-list__tile {
    height: 72px !important;
    min-height: 60px;
  }
}
</style>
